module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0112.jpg?v=83d1fd07";